import React from "react";
import { useSiteContext } from "../../../../../context/SiteContext";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";

const CenteredTemplateOneOneSeven = ({
  logoImage = "/yourLogo.svg",
  logoImagePreview = null,

  titleText = "THE BEST PRODUCT IS HERE",
  titleFont = "Helvetica",
  titleFontSize = "48",
  titleColor = "#32CD32",
  titleTextAlign = "center",
  titleIsBold = true,
  titleIsItalic = false,
  titleIsUnderline = false,
  titleUppercase = true,

  subtitleText = "And it's yours today.",
  subtitleFont = "Helvetica",
  subtitleFontSize = "18",
  subtitleColor = "#90EE90",
  subtitleTextAlign = "center",
  subtitleIsBold = false,
  subtitleIsItalic = false,
  subtitleIsUnderline = false,

  contentImageOne = "/mug.png",
  contentImageOnePreview = null,

  backgroundType = "color",
  backgroundColor = "#2F4F4F",
  backgroundImage = null,

  buttonLabel = "Get started",
  buttonFont = "Helvetica",
  buttonIsBold = false,
  buttonIsItalic = false,
  buttonIsUnderline = false,
  buttonLink = "",
  buttonFontSize = "18",
  buttonFontColor = "#FFFFFF",
  buttonBackgroundColor = "#6B8E23",

  backgroundImagePreview,

  preview = false,
  inmeeting = false,
  center = false,
  onClose,
}) => {
  const { meetingRole, setActiveElement } = useSiteContext();
  const { explicitBoleanCheck } = useEditCtaContext();

  if (
    (backgroundImage && ![null, "null"].includes(backgroundImage)) ||
    backgroundImagePreview
  )
    backgroundColor = "";

  return (
    <div
      className={`relative ${
        !inmeeting ? "h-auto min-h-[283px]" : center ? "!h-[50vh]" : "!h-[15vh]"
      } w-full flex mx-auto items-stretch px-4 md:px-8 py-4 md:py-6 overflow-hidden`}
      style={{ backgroundColor }}
    >
      {/* Close Button */}
      {inmeeting && meetingRole === "moderator" && (
        <button
          className="absolute top-2 right-2 z-20 bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center transition-colors"
          title="Close Banner"
          style={{ right: "8px", top: "8px" }}
          onClick={() => {
            if (meetingRole === "moderator") {
              onClose();
            } else {
              setActiveElement(null);
            }
          }}
        >
          <svg
            className="w-3 h-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}

      {/* Background Image */}
      {(backgroundImage || backgroundImagePreview) && (
        <div
          className="absolute inset-0 w-full h-full opacity-90 z-0"
          style={{
            backgroundImage: `url(${
              backgroundImage instanceof File
                ? backgroundImagePreview
                : backgroundImage
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
      )}

      {/* Content Container - Grid Layout */}
      <div className="relative z-10 w-full grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 h-full">
        {/* Top Left - Logo */}
        <div className="flex items-start justify-start">
          {(logoImage || logoImagePreview) && (
            <div className="flex items-center">
              <img
                src={
                  logoImage instanceof File
                    ? logoImagePreview
                    : logoImage || "/yourLogo.svg"
                }
                alt="logo"
                className="w-20 h-20 md:w-24 md:h-24 object-contain"
              />
            </div>
          )}
        </div>

        {/* Top Right - Title and Subtitle */}
        <div className="flex flex-col items-end justify-start">
          {/* Main Heading */}
          <h1
            className={`${titleUppercase ? "uppercase" : ""} ${
              explicitBoleanCheck(titleIsBold) ? "font-bold" : ""
            } ${explicitBoleanCheck(titleIsItalic) ? "italic" : ""} ${
              explicitBoleanCheck(titleIsUnderline) ? "underline" : ""
            } mb-3 md:mb-4`}
            style={{
              color: titleColor,
              fontSize: `${titleFontSize}px`,
              fontFamily: titleFont,
              textAlign: "center",
              lineHeight: "1.1",
              whiteSpace: "pre-line",
            }}
          >
            {titleText}
          </h1>

          {/* Subtitle - Centered horizontally */}
          <div
            className={`w-full ${
              explicitBoleanCheck(subtitleIsBold) ? "font-bold" : ""
            } ${explicitBoleanCheck(subtitleIsItalic) ? "italic" : ""} ${
              explicitBoleanCheck(subtitleIsUnderline) ? "underline" : ""
            }`}
            style={{
              color: subtitleColor,
              fontSize: `${subtitleFontSize}px`,
              fontFamily: subtitleFont,
              textAlign: "center",
              whiteSpace: "pre-line",
            }}
          >
            {subtitleText}
          </div>
        </div>

        {/* Bottom Left - Product Image */}
        <div className="flex items-end justify-start">
          {(contentImageOne || contentImageOnePreview) && (
            <div className="w-32 h-32 md:w-40 md:h-40 flex-shrink-0">
              <img
                src={
                  contentImageOne instanceof File
                    ? contentImageOnePreview
                    : contentImageOne
                }
                alt="product"
                className="w-full h-full object-contain rounded"
              />
            </div>
          )}
        </div>

        {/* Bottom Right - Button */}
        <div className="flex items-center justify-ce">
          <button
            className={`px-6 py-3 md:px-8 md:py-4 rounded-full transition-all duration-200 shadow-lg hover:shadow-xl ${
              buttonLink ? "cursor-pointer hover:opacity-90" : "cursor-default"
            }`}
            style={{
              backgroundColor: buttonBackgroundColor,
              color: buttonFontColor,
              fontSize: `${buttonFontSize}px`,
              fontFamily: buttonFont,
              fontWeight: explicitBoleanCheck(buttonIsBold) ? "bold" : "normal",
              fontStyle: explicitBoleanCheck(buttonIsItalic)
                ? "italic"
                : "normal",
              textDecoration: explicitBoleanCheck(buttonIsUnderline)
                ? "underline"
                : "none",
            }}
            onClick={() => {
              if (buttonLink) {
                window.open(buttonLink, "_blank");
              }
            }}
          >
            {buttonLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CenteredTemplateOneOneSeven;
